import React from "react";
import { useLocation, useParams } from "react-router-dom";
import PredictInstantBreadcrumb from "./PredictInstantBreadcrumb";
export default () => {
    const { dealId = "" } = useParams();
    const location = useLocation();
    const customerName = location.state?.customerName;
    if (!dealId) {
        return null;
    }
    return (React.createElement(PredictInstantBreadcrumb, { segments: ["Deals Won", customerName ?? "Deal detail"], embedded: true }));
};
